"use strict";

exports.__esModule = true;
exports.USER_LOGOUT = void 0;
const namespace = 'AUTH';
const USER_LOGOUT = namespace + "@USER_LOGOUT";
exports.USER_LOGOUT = USER_LOGOUT;